export const keyName = [{
    'M6-10': [
        'FlowObstruction',
        'HmiStatusLow',
        'FlowIncrease',
        'HmiStatusHigh'
    ]
}
];
